import React, { useState, useEffect } from 'react';
import { withStyles, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import Autocomplete from '@material-ui/lab/Autocomplete';
import match from 'autosuggest-highlight/umd/match';
import parse from 'autosuggest-highlight/umd/parse';
import defaultTheme from './index.theme';

function SearchBar(props) {
  const {
    handleSearch,
    autoSuggestSuggestions,
    selectedDropdownValue,
    classes,
    dispatchAutoSuggest,
    selectedOption,
  } = props;
  const [value, setValue] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    handleSearch();
    setValue('');
  }, [selectedDropdownValue]);

  const onInputChange = (event: Event) => {
    const { value: newValue } = event && event.target;
    setValue(newValue);
    handleSearch();
    if (!newValue || (newValue.length < 3)) {
      setShowSuggestions(false);
    } else {
      setShowSuggestions(true);
      dispatchAutoSuggest(newValue);
    }
  };

  const onSuggestionSelected = (event: Event, suggestionValue) => {
    handleSearch(suggestionValue);
  };

  const renderOption = (option) => {
    const { value: name } = option;
    const matches = match(name, value);
    const parts = parse(name, matches);

    return (
      <div data-apim-test="search-bar-options-container">
        {parts.map((part) => {
          const className = part.highlight ?
            classes.suggestionText__highlightedText : classes.suggestionText__Text;
          return (
            <span key={part.text} className={className}>{part.text}</span>
          );
        })}
      </div>
    );
  };

  const getOptionSelected = (option, valueParam) => (option.key === valueParam.key);

  const getOptionLabel = (option) => (option && option.value) || '';

  const suggestions = showSuggestions ? autoSuggestSuggestions : [];

  const renderInput = (params) => (
    <TextField
      data-apim-test="search-bar-textfield"
      {...params}
      classes={{
        root: classes.autoCompleteTFRoot,
      }}
      fullWidth
      inputProps={{
        ...params.inputProps,
        maxLength: 255,
        value: ((selectedOption && selectedOption.value) || value),
      }}
      margin="none"
      placeholder={`Enter ${selectedDropdownValue} name`}
    />
  );

  return (
    <Autocomplete
      classes={{
        root: classes.autoCompleteRoot,
        focused: classes.autoCompleteFocused,
        inputRoot: classes.autoCompleteInputRoot,
        input: classes.autoCompleteInput,
        popupIndicator: classes.autoCompleteHidden,
        paper: classes.autoCompletePaper,
        popper: showSuggestions ? classes.autoCompleteShow : classes.autoCompleteHidden,
      }}
      disableClearable
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      onChange={onSuggestionSelected}
      onInputChange={onInputChange}
      options={suggestions}
      renderInput={renderInput}
      renderOption={renderOption}
      size="small"
    />
  );
}

SearchBar.propTypes = {
  classes: PropTypes.shape({}),
  handleSearch: PropTypes.func,
  autoSuggestSuggestions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })),
  selectedDropdownValue: PropTypes.string,
  selectedOption: PropTypes.shape(),
  dispatchAutoSuggest: PropTypes.func,
};

export default compose(
    withStyles(defaultTheme),
  )(SearchBar);



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js